import { Facebook, Instagram, Leaf } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative mt-auto bg-background">
      <div className="absolute inset-0 top-[2px]">
        <div className="footer-book-bg h-full w-full" aria-hidden="true" />
      </div>
      <div className="absolute inset-0 top-[2px] bg-primary/40" aria-hidden="true" />
      <div className="relative z-10 h-[3px] w-full bg-destructive" />
      <div className="container relative z-10 mx-auto max-w-7xl px-4 py-12">
        <div className="mb-8 flex items-center justify-center">
          <div className="spark-divider w-full max-w-3xl" />
        </div>

        <div className="grid gap-8 rounded-[2rem] border border-border/30 bg-background/60 px-6 py-8 backdrop-blur-sm md:grid-cols-[1.2fr_1fr_1fr] md:px-8">
          <div>
            <p className="mb-2 text-base font-semibold uppercase tracking-[0.24em] text-foreground">Hintsly</p>
            <p className="text-sm text-muted-foreground">ABN 67 350 155 468</p>
            <p className="mt-1 text-sm text-muted-foreground">™ Hintsly is a registered trademark.</p>
            <p className="mt-3 max-w-md text-sm text-muted-foreground">Give the gift they&apos;ll actually love.</p>
            <div className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(45,90%,50%)]">
              <Leaf className="h-3.5 w-3.5 text-emerald-400" />
              Eco-certified thinking
            </div>
          </div>

          <div className="space-y-3">
            <div className="flex flex-col gap-2">
              <a href="/contact" className="text-lg text-muted-foreground transition-colors hover:text-foreground">gift@hintsly.com.au</a>
            </div>
            <nav aria-label="Site links" className="flex flex-col gap-1.5 text-sm">
              <a href="/about" className="text-muted-foreground transition-colors hover:text-foreground">About Hintsly</a>
              <a href="/blog" className="text-muted-foreground transition-colors hover:text-foreground">Gift ideas &amp; tips</a>
              <a href="/waste-crisis" className="text-muted-foreground transition-colors hover:text-foreground">The waste crisis</a>
              <a href="/community" className="text-muted-foreground transition-colors hover:text-foreground">Community &amp; giving back</a>
              <a href="/events" className="text-muted-foreground transition-colors hover:text-foreground">Events calendar</a>
            </nav>
          </div>

          <div className="flex flex-col gap-3 text-left md:text-right">
            <p className="text-base font-medium text-foreground">Follow us</p>
            <div className="flex gap-3 md:justify-end">
              <a
                href="https://www.instagram.com/hintslyau"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg bg-accent p-2 text-accent-foreground transition-colors hover:bg-primary hover:text-primary-foreground"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/hintslyau"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg bg-accent p-2 text-accent-foreground transition-colors hover:bg-primary hover:text-primary-foreground"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
            <p className="text-sm text-muted-foreground">A more elegant way to hint, share, and gift.</p>
            <div className="flex flex-col gap-0.5 text-xs text-muted-foreground md:items-end">
              <a href="/legal" className="py-1 transition-colors hover:text-foreground">Policies</a>
              <a href="/legal" className="py-1 transition-colors hover:text-foreground">Terms of service</a>
              <a href="/legal" className="py-1 transition-colors hover:text-foreground">Privacy policy</a>
              <a href="/legal#affiliate-disclosure" className="py-1 transition-colors hover:text-foreground">Affiliate disclosure</a>
            </div>
          </div>
        </div>

        <div className="mt-8 space-y-2 text-center">
          <p className="text-xs text-muted-foreground/70">
            Some links on Hintsly are affiliate links — we may earn a small commission at no extra cost to you.{" "}
            <a href="/legal#affiliate-disclosure" className="underline transition-colors hover:text-foreground">Read our affiliate disclosure</a>
          </p>
          <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} Hintsly. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;